<template>
    <b-modal size="md" :id="'modal-cancelar-exame-' + exameAgendado.idExameAgendado" hide-footer centered title="Cancelar Exame Agendado">
		<h4 class="text-left">Você tem certeza que deseja cancelar esse exame?</h4>
		<div class="d-flex w-100 justify-content-between mt-5">
			<b-button @click.prevent="deletarExameAgendado" variant="success" :disabled="carregando">
				<span v-show="!carregando">
					SIM
				</span>
				<b-spinner v-show="carregando" variant="success" class="mx-auto"></b-spinner>
				</b-button>
				<b-button variant="danger" @click.prevent="$bvModal.hide('modal-cancelar-exame-' + exameAgendado.idExameAgendado)">NÃO</b-button>
			</div>
	</b-modal>
</template>

<script>
import ExameAgendadoService from "../../service/ExameAgendadoService.js";

export default{
	name: "ModalCancelarExameAgendado",
	props: [ "exameAgendado" ],
	data() {
		return {
			carregando: false,
		};
	},
	methods: {
		deletarExameAgendado() {
			this.carregando = true;

			ExameAgendadoService.deletar(this.exameAgendado.idExameAgendado)
				.then(() => {
					this.mensagem("Exame Cancelado Com Sucesso!", "Sucesso", "success");
				})
				.then(() => {
					this.$emit("exameCancelado", this.exameAgendado.idExameAgendado);
				})
				.catch((err) => {
					if (err.response) {
						this.mensagem(err.response.data, "Erro", "danger");
					} else {
						this.mensagem("Não foi possível cancelar o exame agendado", "Erro", "danger");
					}
				})
				.finally(() => {
					this.carregando = false;
				});
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autodDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},
};

</script>


<style>
</style>



// WEBPACK FOOTER //
// src/components/Agendamento/ModalCancelarExameAgendado.vue